<template>
  <section class="sponsors general">
    <div class="sponsors__content">
      <h1 class="sponsors__title">
          Media Partners
      </h1>
      <div class="sponsors__logos">
        <template v-for="partner in partners" :key="partner.name">
          <a v-if="partner.url" :href="partner.url" target="_blank">
            <div
              class="sponsors__item single smaller"
            >
              <div class="sponsors__logo-container nobg">
                <img :src="partner.logo" :alt="partner.name" :class="partner.class || 'full-logo'">
              </div>
            </div>
          </a>
          <div
            v-else
            class="sponsors__item single smaller"
          >
            <div class="sponsors__logo-container nobg">
              <img :src="partner.logo" :alt="partner.name" :class="partner.class || 'full-logo'">
            </div>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import '@/styles/components/sponsors.scss';
</style>

<script>
import { ref } from 'vue';

export default {
  setup() {
    const partners = ref([
      { logo: require('@/assets/logos/coindesk.png'), class: 'full-logo', name: 'CoinDesk', url: 'https://www.coindesk.com/' },
      { logo: require('@/assets/logos/tokenpost.png'), class: 'full-logo', name: 'Tokenpost', url: 'https://www.tokenpost.com/' },
      { logo: require('@/assets/logos/upside.png'), class: 'full-logo', name: 'Upside', url: 'https://www.upside.gg/' },
      { logo: require('@/assets/logos/despread.svg'), class: 'full-logo', name: 'DeSpread', url: 'https://despread.io/' },
    ]);
    return {
      partners
    };
  },
};
</script>
